interface TooltipPayloadItem {
  dataKey?: string | number
  name?: string
  value?: number | string
  color?: string
}

interface ChartTooltipProps {
  active?: boolean
  payload?: TooltipPayloadItem[]
  label?: string | number
}

// Shared opaque tooltip for analytics charts. Uses Tailwind classes so the
// background follows the active theme (.dark / .light on <html>) — recharts'
// inline-style `contentStyle` with CSS-var backgrounds can render transparent
// in some draw paths, so a real DOM node with utility classes is the safe
// way to keep the tooltip readable in both themes.
export default function ChartTooltip({ active, payload, label }: ChartTooltipProps) {
  if (!active || !payload || payload.length === 0) return null

  return (
    <div className="rounded-lg border border-border bg-card text-card-foreground shadow-md px-3 py-2 text-xs">
      {label !== undefined && (
        <div className="font-medium mb-1 text-card-foreground">{label}</div>
      )}
      <div className="space-y-0.5">
        {payload.map((entry, idx) => (
          <div
            key={`${entry.dataKey ?? entry.name ?? idx}`}
            className="flex items-center gap-2 tabular-nums"
          >
            <span
              className="inline-block w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-muted-foreground">{entry.name}</span>
            <span className="ml-auto font-medium">
              {typeof entry.value === 'number'
                ? entry.value.toLocaleString()
                : String(entry.value ?? '')}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
